export function formatAcademicLevel(obj) {
  return `${obj?.educationLevel} - ${obj?.course} (${obj?.year}) | ${obj?.local}`;
}
